import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import App from "./components/App/App.js";
import reportWebVitals from "./reportWebVitals";
import "./styles/index.scss";
import { BDCAuthProvider } from  "./components/contextServices/bdcUserContext";

ReactDOM.render(
  <React.StrictMode>
    <BDCAuthProvider>
        <App />
    </BDCAuthProvider>
  </React.StrictMode>,
  document.getElementById("root")
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
